import {
  BookingScheduleDto,
  BookingScheduleInterface
} from "../../../features/Booking-Form/typings/booking.types";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { SCHEDULE_QUERY_STALE_TIME_MS } from "./schedule-query-cache.constants";

type Params = {
  bookingScheduleDto: BookingScheduleDto;
  /** Workplace meta or parking/EV placeTypes — gates `GET /booking-schedule/place`. */
  placeScheduleEnabled: boolean;
  excludeVisitOnly?: boolean;
};

/** By default requests non–visit-only workplace rows (`visitOnly=false`). Pass `{ excludeVisitOnly: false }` for all rows. */
export function useRemoteFetchPlaceSchedule(params: Params) {
  const { bookingScheduleDto, placeScheduleEnabled } = params;
  const { userIds, startDate, endDate } = bookingScheduleDto;
  const excludeVisitOnly = params.excludeVisitOnly ?? true;

  return useRemoteQuery<BookingScheduleInterface[]>({
    queryKey: ["placeSchedule", bookingScheduleDto, excludeVisitOnly],
    url: "/booking-schedule/place",
    params: {
      userIds,
      startDate,
      endDate,
      ...(excludeVisitOnly ? { visitOnly: false } : {})
    },
    enabled: !!startDate && !!endDate && placeScheduleEnabled,
    staleTime: SCHEDULE_QUERY_STALE_TIME_MS
  });
}
